module.exports = __webpack_public_path__ + "static/a_large-21c72c4213a27d6c2cc59518c98dd2d1.jpg";